import _ from 'underscore'
import resolve from 'ioc/resolve'
import $pageConfig from 'webutils/services/page-config'
import $session from 'servicestack/session'
import webcolors from 'webcolors/webcolors'
import webfonts from 'webfonts/webfonts'
import templateUrl from 'emun.on-demand/layers/design-layer-field.htm'
import 'emun.on-demand/layers/design-layer-field.angle.htm'
import 'emun.on-demand/layers/design-layer-field.arrangement.htm'
import 'emun.on-demand/layers/design-layer-field.center.htm'
import 'emun.on-demand/layers/design-layer-field.color.htm'
import 'emun.on-demand/layers/design-layer-field.opacity.htm'
import 'emun.on-demand/layers/design-layer-field.scale.htm'
import 'emun.on-demand/layers/design-layer-field.trash.htm'
import 'emun.on-demand/popovers/design-layer-popover.angle.htm'
import 'emun.on-demand/popovers/design-layer-popover.opacity.htm'
import 'emun.on-demand/popovers/design-layer-popover.scale.htm'

class DesignLayerFieldController {
    constructor($scope, $transclude) {
        const $ctrl = this;
        $ctrl.webcolors = webcolors;
        $ctrl.$pageConfig = $pageConfig;
        $ctrl.$session = $session;
    }

    $onInit() {
        const $ctrl = this;
        $ctrl.templateUrl = `design-layer-field.${$ctrl.type}.htm`;
        $ctrl.popoverTemplateUrl = `design-layer-popover.${$ctrl.type}.htm`;
        if (!$ctrl.popoverPlacement) $ctrl.popoverPlacement = 'top';
        if (!$ctrl.size) $ctrl.size = 'md';
        if (!$ctrl.maxWidth) $ctrl.maxWidth = '108px';
        if (!$ctrl.minWidth) $ctrl.minWidth = '45px';
    }
}

let DesignLayerField = {
    bindings: {
        layer: '<',
        designer: '<',
        type: '@',
        popoverPlacement: '@',
        popoverMaxWidth: '@',
        popoeverMinWidth: '@',
        size: '@',
        maxWidth: '@',
        minWidth: '@'
    },
    controller: DesignLayerFieldController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default DesignLayerField;